import { Card } from '../ui';

type Props = { brief?: string[] };

export function CreativeDirectorCard({ brief = [] }: Props) {
  return (
    <Card padding="sm" className="border-purple-200 bg-purple-50/20 dark:border-purple-900 dark:bg-purple-950/20">
      <p className="text-xs font-semibold uppercase tracking-wide text-purple-600">AI Creative Director</p>
      <ul className="mt-3 space-y-2">
        {brief.map((line) => (
          <li key={line} className="flex gap-2 text-sm text-slate-600 dark:text-slate-400">
            <span className="text-purple-500">◈</span>
            {line}
          </li>
        ))}
      </ul>
    </Card>
  );
}
